module.exports = __webpack_public_path__ + "static/media/2021-cd.ea7a71ab.jpg";